<template>
	<div class="basic-layout-h">
		<left-menu />
		<div class="main-container">
			<keep-alive>
				<router-view />
			</keep-alive>
		</div>
	</div>
</template>

<script>
	import LeftMenu from '@/components/controlsH/LeftMenu.vue';
	export default {
		name: 'BasicLayoutH',
		components: {
			LeftMenu
		},
		data() {
			return {
				
			}
		},
		computed: {
			
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">

	.basic-layout-h {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 100%;
		//background-image: url("~@/assets/page-sample.jpg");
		//background-size: 100%;
		//background-repeat: no-repeat;
	}

	.main-container {
		padding: calc(28px * var(--scale-rate)) calc(160px * var(--scale-rate)) 0 0;
		flex: 1;
		overflow-y: auto;
		//background-image: url("~@/assets/page-sample-main3.jpg");
		//background-size: 100%;
		//background-repeat: no-repeat;
	}
</style>